var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44194 11.7434L5.76842 6.56589L13.4753 14.2727L8.29773 15.5992L8.2712 15.606L8.25184 15.6254L7.41215 16.4651L7.34144 16.5358L7.41215 16.6065L9.99309 19.1874L9.12688 20.0536L6.54594 17.4727L6.47523 17.402L6.40452 17.4727L5.22895 18.6483C4.9673 18.9099 4.65774 19.0403 4.29524 19.0427C3.93282 19.0451 3.62575 18.9189 3.36838 18.6615L1.37964 16.6728C1.12227 16.4154 0.996076 16.1084 0.998476 15.7459C1.00088 15.3834 1.13125 15.0739 1.3929 14.8122L4.41578 11.7893L4.43515 11.77L4.44194 11.7434ZM2.24585 15.6652L2.17514 15.7359L2.24585 15.8066L4.23459 17.7953L4.3053 17.866L4.37601 17.7953L7.64832 14.523L10.9307 13.6738L11.1001 13.63L10.9764 13.5063L6.53489 9.06476L6.41119 8.94106L6.36737 9.11043L5.51816 12.3929L2.24585 15.6652ZM12.8635 6.32473L15.2411 3.94708L16.0941 4.80003L13.7164 7.17767L12.8635 6.32473ZM19.086 9.99971L19.2499 11.2016L15.924 11.7118L15.7601 10.5099L19.086 9.99971ZM10.0421 0.955275L9.56445 4.21403L8.36256 4.05013L8.84023 0.79138L10.0421 0.955275ZM12.4937 11.6649L8.37631 7.54742C8.85431 7.54295 9.33232 7.62345 9.81081 7.78955C10.3615 7.9807 10.8582 8.29687 11.3012 8.73994C11.7443 9.183 12.0605 9.67971 12.2516 10.2304C12.4177 10.7089 12.4982 11.1869 12.4937 11.6649Z",
    fill: "white",
    stroke: "#005068",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.8d1d04a55011972f83d182fa98de9643.svg";
export { ForwardRef as ReactComponent };